import { useState } from 'react';
import { Button } from 'framework/ui/mui-builder';
import Collapse from '@mui/material/Collapse';
import { Box } from '@mui/material';
import { TogglerInput, useInputHelper } from 'framework/form';

const ShareInstantFeedbackToggle = ({ source }: { source: string }) => {
  const { getValue, getRawOnChangeCallback } = useInputHelper({ source });
  const [isConfirmationShown, setIsConfirmationShown] = useState(false);
  const rawOnChangeCallback = getRawOnChangeCallback() || (() => {});
  const value = getValue();

  const onShareToggleClick = ({ isSharedWithEmployee }: Dictionary<boolean>) => {
    if (isSharedWithEmployee) {
      setIsConfirmationShown(true);
    } else {
      hideConfirmation();
      rawOnChangeCallback({
        [source]: isSharedWithEmployee,
      });
    }
  };

  const hideConfirmation = () => {
    setIsConfirmationShown(false);
  };

  const onConfirm = () => {
    hideConfirmation();
    rawOnChangeCallback({
      [source]: true,
    });
  };

  return (
    <Box mt={-1.5} mb={-1}>
      <TogglerInput
        source={source}
        value={!!value}
        checkedValue="Yes"
        uncheckedValue="No"
        label="Share my name and my feedback with colleague"
        onChangeCallback={onShareToggleClick}
        isControlledInput
        sx={{
          mb: 1.5,
          '& .MuiSwitch-track': {
            '&::before, &::after': {
              fontSize: '12px',
            },
            '&::before': {
              left: '11px !important',
            },
          },
        }}
      />
      <Collapse
        in={isConfirmationShown}
        sx={{
          '.MuiCollapse-wrapperInner > div': {
            margin: '0',
            display: 'flex',
            justifyContent: 'center',
            textAlign: 'center',
          },
          '.MuiCollapse-wrapperInner > div:nth-child(2)': { margin: '10px 0 30px' },
          '.MuiCollapse-wrapperInner button': { minWidth: '100px' },
        }}
      >
        <div>Are you sure you want to share your name and feedback with colleague?</div>
        <div>
          <Button key="confirmBtn" sx={{ marginRight: '10px' }} onClick={onConfirm}>
            Yes
          </Button>
          <Button key="cancelBtn" variant="outlined" onClick={hideConfirmation}>
            No
          </Button>
        </div>
      </Collapse>
    </Box>
  );
};

export default ShareInstantFeedbackToggle;
